export interface NotificationsRequest {
  cursor?: string | null;
  pageSize?: number;
  filterCriteria?: FilterCriteria;
}

export interface NotificationsPayloadResponse {
  notifications: Notification[];
  cursor?: string;
}

export interface MarkNotificationsRequest {
  notifications: Notification[];
  status: NotificationStatus;
}

export interface MarkNotificationsResponse {
  notificationIds: string[];
}

export interface NotificationsCountPayloadResponse {
  unreadCount: number;
}

export interface UpdateNotificationPreferenceRequest {
  webNotificationPreference: NotificationPreference;
}
export interface UpdateNotificationPreferenceResponse {
  updated?: boolean;
}

export interface Notification {
  username: string;
  avatarSrc: string;
  threadId: string;
  postId?: string;
  groupId?: string;
  notificationId: string;
  notificationOn: NotificationOn;
  notificationType: NotificationType;
  relationship: NotificationRelationship;
  message: string;
  status: NotificationStatus;
  updatedAt: number;
  replyCount: number;
  voteCount: number;
  membersAddedToGroupCount: number;
  totalDiscussionsInGroup: number;
  userId?: string;
  daysSilenced?: number;
}

export enum FilterCriteria {
  ALL = 'ALL',
  UNREAD = 'UNREAD',
}

export interface GetNotificationPreferenceResponse {
  createdAt: number,
  updatedAt: number,
  userId: string,
  webNotificationPreference: NotificationPreference
}

export interface NotificationPreference {
  notificationOnGroupMemberAdditionEnabled?: boolean,
  notificationOnNewDiscussionInGroupEnabled?: boolean,
  notificationOnPinEnabled: boolean,
  notificationOnPostEnabled: boolean,
  notificationOnSolutionEnabled: boolean,
  notificationOnTagEnabled: boolean,
  notificationOnVoteEnabled: boolean
}

export enum NotificationType {
  AmazonCloseThread = 'AMAZON_CLOSE_THREAD',
  AmazonDeletePost = 'AMAZON_DELETE_POST',
  AmazonDeleteThread = 'AMAZON_DELETE_THREAD',
  AmazonEditPost = 'AMAZON_EDIT_POST',
  AmazonEditThread = 'AMAZON_EDIT_THREAD',
  AmazonSuppressPost = 'AMAZON_SUPPRESS_POST',
  AmazonSuppressThread = 'AMAZON_SUPPRESS_THREAD',
  Mentioned = 'MENTIONED',
  NewDiscussionGroup = 'NEW_DISCUSSION_GROUP',
  Pinned = 'PINNED',
  Quoted = 'QUOTE',
  ReplyOnThread = 'REPLY_THREAD',
  ReplyOnPost = 'REPLY_POST',
  Silenced = 'SILENCED',
  Solution = 'SOLUTION',
  Unsilenced = 'UNSILENCED',
  VoteOnThread = 'VOTE_THREAD',
  VoteOnPost = 'VOTE_POST',
  Warned = 'WARNED',
}

export enum NotificationRelationship {
  ThreadOwner = 'THREAD_OWNER',
  PostOwner = 'POST_OWNER',
  RepliedOnThread = 'REPLIED_ON_THREAD',
  RepliedOnPost = 'REPLIED_ON_POST',
  VotedOnThread = 'VOTED_ON_THREAD',
  VotedOnPost = 'VOTED_ON_POST',
  GroupMember = 'GROUP_MEMBER',
}

export enum NotificationOn {
  Thread = 'THREAD',
  Post = 'POST',
  Group = 'GROUP',
  Message = 'MESSAGE',
  None = '',
}

export enum NotificationStatus {
  Read = 'READ',
  Unread = 'UNREAD',
}

export enum UserActivityType {
  CreatedDiscussion = 'CREATED_DISCUSSION',
  RepliedToDiscussion = 'REPLIED_TO_DISCUSSION',
}
